import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
// import PropTypes from 'prop-types';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import axios from 'axios'
import { genURL, gengetURLTEST } from '../../../_getjson';

export default function Invdebt(props) {
    const { parm } = props
    const [listitem, setListitem] = useState([])
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);
    const [datasub, setdatasub] = useState([]);
    const DOCNO = useRef();
    const Search = useRef();
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = () => {
        var url = "CSSELSALERETREQREFSUB/GetALL?ARCODE=" + parm.DOCNO
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 3600 }).then((res) => {
            console.log(res.data);
            setListitem(...[res.data])
        }).finally(_ => {

        })
    }
    const Get_Data = () => {
        var url = "CSSELSALERETREQREFSUB/GetALL?ARCODE=" + parm.DOCNO.trim() + "&DATA=" + Search.current.value
        axios.get(genURL(url), { timeout: 3600 }).then((res) => {
            console.log(res.data);
            setListitem(res.data)
        }).finally(_ => {

        })
    }
    const onRowDoubleClick = (row) => {
        handleRowSelect(row, true, 1)
        // row.select = 1

    }
    const sendData = async () => {
        var table = []
        console.log(listitem);
        let j = 0
        for (let i = 0; i < listitem.length; i++) {
            if (Number(listitem[i].select) === 1) {
                table[j] = await listitem[i]
                j++
            }
        }
        console.log(table);
        let resdatas = []
        resdatas.push(false)
        resdatas.push(table)
        props.resdata(resdatas)
    }
    const indexN = (cell, row, enumObject, index) => {
        return (<div>{index + 1}</div>)
    }
    const handleRowSelect = (row, isSelected, e) => {
        console.log(isSelected);
        row.select = isSelected ? 1 : 0
        if (e === 1) {
            sendData()
        }
    }
    const handleSelectAll = (isSelected, rows) => {
        for (let i = 0; i < rows.length; i++) {
            rows[i].select = isSelected ? 1 : 0
        }
        console.log(rows);

    }
    const selectRow = {
        mode: 'checkbox',
        bgColor: '#2e6da469',
        onSelect: handleRowSelect,
        onSelectAll: handleSelectAll,
    };
    return (
        <div className="popup">
            <div className="popup_inner">
                <div className="PopUpOtherDivH" align="left">
                    <div className="PopUpOtherDivH1">
                        <i className="fas fa-search"> ค้นหาใบส่งของ/ใบกำกับภาษี-SellnvSaleRef</i>
                    </div>
                    <div className="PopUpOtherDivH2" >
                        <i className="fas fa-times"></i>
                    </div>
                </div>
                <div className="panel-body divTable" align="left">
                    <div className="input-group width-grop">
                        <input type="text" className="form-control" placeholder="ค้นหาเลขที่เอกสาร" onKeyUp={(e) => { if (e.key === "Enter") { Get_Data() } }} ref={Search} />
                        <input type="hidden" className="form-control " ref={DOCNO} />
                        <span className="input-group-addon txt-img icon">
                            <i className="fas fa-search" onClick={Get_Data.bind()}></i>
                        </span>
                        <span className="input-group-addon txt-img icon">
                            <i className="fas fa-sync-alt" onClick={() => { componentdidmount() }}></i>
                        </span>
                    </div>

                    <BootstrapTable
                        keyField='PRODUCTCODE'
                        data={listitem}
                        selectRow={selectRow}
                        options={{
                            onRowDoubleClick: onRowDoubleClick,
                            noDataText: "ไม่พบข้อมูล"
                        }}
                        height='650'
                    >
                        <TableHeaderColumn dataAlign="center" width="45" dataField="number" dataFormat={indexN} ></TableHeaderColumn>
                        <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='DOCNO' dataAlign="left" editable={false} > เลขที่เอกสาร </TableHeaderColumn>
                        <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='PRODUCTCODE' editable={false}> รหัสสินค้า </TableHeaderColumn>
                        <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='PRODUCTNAME' editable={false}> ชื่อสินค้า </TableHeaderColumn>
                        <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='UNITNAME' dataAlign="left" editable={false}> หน่วย </TableHeaderColumn>
                        <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='QUANTITY' dataAlign="left" editable={false}> ปริมาณ </TableHeaderColumn>
                        <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='UNITPRICE' dataAlign="left" editable={false}> ราคา/หน่วย </TableHeaderColumn>
                        <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='DISCWORD' dataAlign="left" editable={false}> ลด </TableHeaderColumn>
                        <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='SALENAME' dataAlign="right" editable={false}> พนักงานขาย </TableHeaderColumn>
                    </BootstrapTable>
                    <Snackbar place="br"
                        color={color}
                        icon={icon}
                        autoClose={autoClose}
                        message={messagealert}
                        open={opensnackbar}
                        closeNotification={() => { setopensnackbar(false) }}
                        close />
                    <br></br>
                    <button className="PUSDbtn" style={{ float: 'right' }} onClick={() => { sendData(true) }}>ตกลง</button>
                </div>
            </div>
        </div>
    )
}

